import SafeImage from '../SafeImage';
import Link from 'next/link';
import { BlogDocument } from '@util/types/firestore/blog';

type Props = {
  blog: BlogDocument;
};

const BlogLink = ({ blog }: Props) => {
  const date = new Date(blog.created);
  return (
    <Link
      href={`/blog/${blog.slug}`}
      className="flex w-full flex-col  gap-[1.6rem] sm:max-w-[38.4rem]"
    >
      {/* image */}
      <div className="relative h-[22rem] w-full min-w-[31rem] self-start overflow-clip rounded-[0.6rem] sm:h-[25rem]">
        <SafeImage
          alt={blog.title}
          src={blog.thumbnail}
          fill={true}
          style={{ objectFit: 'cover' }}
        />

        {/* bottom right */}
        <div className="absolute bottom-4 right-4 text-right text-brand-white">
          <div className="text-h2 font-semibold">{date.getDate()}</div>
          <div className="font-medium opacity-80">
            {date.toLocaleDateString('en-us', {
              month: 'short',
              year: 'numeric',
            })}
          </div>
        </div>
      </div>
      {/* bottom left */}
      {blog.tags.length > 0 && (
        <div className="  w-min whitespace-nowrap rounded-[5.6rem] bg-brand-primary-lighter px-[1.6rem] py-[0.6rem]  text-[1.3rem] font-semibold text-brand-primary">
          {blog.tags[0]}
        </div>
      )}
      {/* info */}
      <div className="grow">
        <div className="flex w-full flex-col text-left sm:gap-[.4rem]">
          {new Date(blog.created).toLocaleDateString('en-us', {
            month: 'long',
            day: '2-digit',
            year: 'numeric',
          })}
          <p className="text-[1.8rem] font-semibold text-black">{blog.title}</p>
          <p className="text-brand-lightest-black">
            {blog.description?.substring(0, 100)}
          </p>
        </div>
      </div>
    </Link>
  );
};

export default BlogLink;
